import mongoose from 'mongoose';
import '../config/server-config';
export class MongooseSchemaBuilder {
    constructor() { }
    buildSchema(schemas) {
        schemas.forEach((entitySchema) => {
            this.configureEntitySchema(entitySchema);
        });
    }
    configureEntitySchema(entitySchema) {
        delete mongoose.connection.models[entitySchema.options.alias];
        const definition = Object.keys(entitySchema.properties).reduce((acc, propertyKey) => {
            const typeDef = entitySchema.properties[propertyKey].type;
            acc[propertyKey] = typeDef;
            return acc;
        }, {});
        const EntitySchema = new mongoose.Schema(definition, {
            collection: entitySchema.options.mongoCollectionName,
        });
        mongoose.model(entitySchema.options.alias, EntitySchema);
    }
}
